(function(){
window.__chLoadedAssets=window.__chLoadedAssets||{};
if(window.__chLoadedAssets["ch-pubsub.js"])return;
window.__chLoadedAssets["ch-pubsub.js"]=true;
let subscribers = {};

function ChSubscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function ChPublish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

window.ChSubscribe = ChSubscribe;
window.ChPublish = ChPublish;
})();
